import { render, staticRenderFns } from "./OnboardingConfirmation.vue?vue&type=template&id=bddf64f8&scoped=true"
import script from "./OnboardingConfirmation.vue?vue&type=script&lang=js"
export * from "./OnboardingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OnboardingConfirmation.vue?vue&type=style&index=0&id=bddf64f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf64f8",
  null
  
)

export default component.exports